import { Box, Typography } from "@mui/material";
import { tips } from "../utils/tips";
import Loading from "./Loading";

const LoadingWithTip: React.FC = () => {
    const randomTip = tips[Math.floor(Math.random() * tips.length)];

    return (
        <Box
            sx={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                px: 2,
                textAlign: "center",
            }}
        >
            <Loading />
            <Typography variant="h6" sx={{ fontFamily: "Playfair Display", fontWeight: 600, mt: 3 }}>
                {randomTip}
            </Typography>
        </Box>
    );
};

export default LoadingWithTip;
